// utils/formatters.js
export function formatNumber(value) {
    if (value >= 10000000) {
        const num = value / 10000000;
        return `${num % 1 === 0 ? num : num.toFixed(2)} Cr`;
    } else if (value >= 100000) {
        const num = value / 100000;
        return `${num % 1 === 0 ? num : num.toFixed(2)} L`;
    } else if (value >= 1000) {
        const num = value / 1000;
        return `${num % 1 === 0 ? num : num.toFixed(2)} K`;
    } else {
        // For numbers < 1000, show decimals only if needed
        return value % 1 === 0 ? value.toString() : parseFloat(value).toFixed(2);
    }
}

